
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import { InAppNotificationClient } from '@/services/Services';
import store from '@/store';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class moneyTransferReceived extends Vue {

    @Prop() item: OM.MoneyTransferReceived;

    onClick(){
        this.$router.push('/network/walletTransactions')
        .then(x => {
            this.$emit('clicked');
        });
    }

}
